import { UserModel } from './user.model';

export class EngagementModel {
  Id: number;
  ReportingCurrencyId: number;
  EngagementName: string;
  PaceId: string;
  ReportingCurrencyName?: string;
  FiscalYearMonth: number;
  FiscalYearMonthName?: string;
  Status: boolean;
  UserNames?: UserModel[];
  Users?: string;
  IsDatabookFinished?: boolean;
  RegionId?: number;
  RegionName?: string;
  CountryId: number;
  CountryName?: string;
  TemplateId: number;
  TemplateName?: string;
  CreatedBy: number;
  ModifiedBy?: number;
  StepId?: number;
  FlatFileStepID?: number;
  IsFlatfileTemplateUploaded?: boolean;
  DaiseyProjectId?: string;
  RedirectToVerification?: number;
  DatabookVersion: number;
  MappingLevel: number;
  IsLocalCopyUploaded: boolean;
  Type: string;
  isEditable: boolean;
  PowerBIStatus?: string;
  PowerBIRequestId?: number;
  PowerBIWorkspaceId?: number;
  AccCalendarId: number;
  AccountCalendar?:string;
  FirstDateOfFiscalYear ?: Date;
  StartDateOfSourceData ?: string;
  FirstInstanceOfFifthWeekYear?: number;
  isPLAcccounts: boolean;
  IsAccountMappingDone?: number;
  CurrencySymbol?: string;
  CountryCode?: string;
  FiftythirdWeekYear:any;
  IsPreferredSourceEndDate?:boolean;
  AmountInMultiples?: number;
  IsOtherIncExpIncluded?: boolean;
  LanguageName?: string;
  LanguageId?: number;
  LanguageCode?:string;
  IsDynamicDatabook: boolean;
  ProjectCategoryId: number;
  IsTestProjectWorkspaceEnabled?: boolean;
  IsForecastIncl?: boolean;
  ForecastMonth?: number;
  ForecastYear?: number;
  IsEngagementAvailable?: boolean;
  IsPnP?: boolean;
  IsCustomizedEngagement?: boolean;
  WBStatus?:boolean;
  IsWorkBench?:boolean;
}
